module.exports = __webpack_public_path__ + "img/condition_pink.22db0589.svg";